<template>
    <div class="LocationObjects">
        <div class="LocationObjects__content">
            <div class="section-title">{{location_type}} {{object.location_name}}</div>
            <div class="LocationObjects__images-slier" v-if="object.type !== 'town_flats'">
                <ImageSlider group="group1" ref="slider" :images="images" :show-navigation="true"
                             @open="$emit('open', $event)"
                             :show-pagination="false"/>
            </div>
            <hooper
                    v-if="object.type !== 'town_flats'"
                    class="LocationObjects__gallery hide-mobile"
                    group="group1"
                    :itemsToShow="4"
                    :center-mode="true"
                    :infinite-scroll="true"
                    :wheel-control="false"
            >
                <slide
                        class="LocationObjects__gallery-image-wrapper"
                        v-for="(image, index) of images"
                        :key="index"
                >
                    <img
                            class="LocationObjects__gallery-image"
                            :src="image"
                            @click="onImageSelect(index)"
                            alt=""
                    >
                </slide>

                <!--                    <hooper-navigation slot="hooper-addons"></hooper-navigation>
									<hooper-pagination slot="hooper-addons"></hooper-pagination>-->
            </hooper>

            <div class="LocationObjects__text" v-html="object.location_descr">

            </div>
        </div>
        <yandex-map
            class="LocationObjects__map"
            :coords="object.cords"
            :zoom="15"
            :controls="['zoomControl']"
        >
            <ymap-marker
                :marker-id="object.id"
                :coords="object.cords"
                :balloon-template="`<b>${object.name}</b><br>${object.location}`"
            />
        </yandex-map>
    </div>
</template>

<script>
import ImageSlider from "@/components/Object/ImageSlider";
import {Hooper, Slide} from 'hooper';

export default {
    name: "LocationObjects",
    components: {
        ImageSlider,
        Hooper,
        Slide,
    },
    props: {
        object: Object,
        //location_type: String
    },
    /*data: () => ({
        images: [
            'https://source.unsplash.com/random',
            'https://source.unsplash.com/random',
            'https://source.unsplash.com/random',
            'https://source.unsplash.com/random',
        ],
    }),*/
    methods: {
        onImageSelect(index) {
            this.$refs.slider.$refs.hooper.slideTo(index);
        }
    },
    computed: {
        images: function() {
            let obj = this.$store.state.objects.filter(object => object.id === this.$route.params.id);
            return obj[0].location_foto;
        },
        location_type() {
            let obj = this.$store.state.objects.filter(object => object.id === this.$route.params.id);
            console.log(obj);
            if (obj[0].type === 'country_houses' || obj[0].type === 'country_lands') {
                return ''; //'Коттеджный поселок';
            }

            return '';
        }
    }
}
</script>

<style lang="scss">
.LocationObjects {
  padding: 40px 20px 20px;
  border-radius: 16px;
  background-color: $white;

  @include mobile {
    border-radius: 0;
    padding: 0 0 40px;
  }

  .section-title {
    margin-bottom: 32px;
  }

  &__content {
    padding: 16px 16px 24px;
  }

  &__images-slier {
    border-radius: 16px;
    overflow: hidden;
    height: 550px;
    margin-bottom: 24px;

    @include tablet {
      height: 370px;
      border-radius: 8px;
      margin-bottom: 16px;
    }

    @include mobile {
      height: 190px;
    }
  }

  &__gallery {
    outline: none;
    height: 127px;
    margin-bottom: 40px;

    @include tablet {
      grid-gap: 16px;
    }
  }

  &__gallery-image-wrapper {
    padding: 0 12px;

    &.is-current .LocationObjects__gallery-image {
      border: solid 2px $primary;
    }

    @include tablet {
      border-radius: 8px
    }
  }

  &__gallery-image {
    width: 100%;
    height: 100%;
    cursor: pointer;
    border-radius: 16px;
    background-color: $grayLight;
    background-size: cover;
    background-position: center;
    width: 100%;
    //height: 100%;
    object-fit: cover;
    border-radius: 16px;
    background-color: $grayLight;

    @include tablet {
      border-radius: 8px
    }
  }

  &__text {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 24px;

    @include mobile {
      margin-bottom: 0;
    }
  }

  &__map-settings {
    margin-bottom: 20px;
    display: flex;
    overflow-x: auto;
  }

  &__settings-button {
    white-space: nowrap;

    button {
      font-size: 14px;
      height: 40px;
    }

    & + & {
      margin-left: 16px;
    }
  }

  &__map {
    height: 440px;
    background-color: $grayLight;

    @include mobile {
      height: 510px;
    }
  }
}
</style>
